import { useMemo } from 'react'
import { cn } from '@/lib/utils'
import { splitTextEmojiSegments } from '@/lib/splitTextEmoji'

interface BannerTitleTextProps {
  title: string
  className?: string
}

export function BannerTitleText({ title, className }: BannerTitleTextProps) {
  const segments = useMemo(() => splitTextEmojiSegments(title), [title])
  const hasEmoji = segments.some((segment) => segment.kind === 'emoji')

  if (!hasEmoji) {
    return (
      <h1 className={cn('gold-gradient-text', className)}>
        {title}
      </h1>
    )
  }

  return (
    <h1 className={className}>
      {segments.map((segment, index) =>
        segment.kind === 'emoji' ? (
          <span
            key={`${index}-${segment.value}`}
            className="text-inherit not-italic"
            aria-hidden={segment.value.trim().length === 0}
          >
            {segment.value}
          </span>
        ) : (
          <span key={`${index}-${segment.value}`} className="gold-gradient-text">
            {segment.value}
          </span>
        )
      )}
    </h1>
  )
}
